"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = require("prop-types");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  stroke: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n          align-self: center;\n        "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n          position: absolute;\n          left: 50%;\n          top: 50%;\n          transform: translate(-50%, -50%);\n          z-index: 3;\n        "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  opacity: 1;\n  height: 80px;\n  width: 80px;\n  min-width: 80px;\n  min-height: 80px;\n  transform-origin: 40px 40px 40px;\n  transition: 0.5s;\n  animation: spinnerAnimation 1.3s infinite cubic-bezier(0.53, 0.21, 0.29, 0.67);\n\n  ", ";\n  @keyframes spinnerAnimation {\n    0% {\n      transform: rotate(0deg);\n    }\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var LoadingSpinner = function LoadingSpinner(_ref) {
  var isAbsolute = _ref.isAbsolute,
      className = _ref.className;
  return _react.default.createElement(Spinner, {
    id: "loadingSpinner",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    className: className,
    isAbsolute: isAbsolute
  }, _react.default.createElement("defs", null, _react.default.createElement("path", {
    id: "a",
    d: "M0 0h40v40H0z"
  })), _react.default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _react.default.createElement(Circle, {
    cx: "40",
    cy: "40",
    r: "38",
    opacity: "0.1",
    strokeWidth: "2.817"
  }), _react.default.createElement("g", {
    transform: "translate(40)"
  }, _react.default.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, _react.default.createElement("use", {
    href: "#a"
  })), _react.default.createElement(Circle, {
    cy: "40",
    r: "38",
    strokeWidth: "2.817",
    mask: "url(#b)"
  }))));
};

var Spinner = _styledComponents.default.svg(_templateObject(), function (_ref2) {
  var isAbsolute = _ref2.isAbsolute;
  return isAbsolute ? (0, _styledComponents.css)(_templateObject2()) : (0, _styledComponents.css)(_templateObject3());
});

var Circle = _styledComponents.default.circle(_templateObject4(), function (_ref3) {
  var theme = _ref3.theme;
  return theme.brand.primary;
});

LoadingSpinner.defaultProps = {
  isAbsolute: false
};
LoadingSpinner.propTypes = {
  className: _propTypes.string,
  isAbsolute: _propTypes.boolean
};
var _default = LoadingSpinner;
exports.default = _default;